module.exports = __webpack_public_path__ + "svg/overview.042b4f7a58b4494943cdc3866d3ac34f.svg";